/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Ricerca in due passaggi (snippets/andpow-searchStrict.liquid): il form cerca subito in modo stretto */
document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!window.EyeSearch || !window.routes || form.getAttribute('action') !== window.routes.searchUrl) return;

  var input = form.querySelector('[name="q"]');
  // Sotto i 3 caratteri il form va alla pagina di ricerca, che mostra solo l'avviso
  if (!input || window.EyeSearch.tooShort(input.value) || !window.EyeSearch.strict(input.value)) return;

  event.preventDefault();
  var params = new URLSearchParams(new FormData(form));
  window.EyeSearch.expand(input.value).then(function (strictQuery) {
    params.set('q', strictQuery);
    params.set('strict', '1');
    window.location.href = form.getAttribute('action') + '?' + params.toString();
  });
});

/* Open when someone clicks on the span element */
function openNav() {
  //document.getElementById("overlayNav").style.width = "250px";
  $('#overlayNav').css("margin-right","0");
}

/* Close when someone clicks on the "x" symbol inside the overlay */
function closeNav() {
  //document.getElementById("overlayNav").style.width = "0%";
   $('#overlayNav').css("margin-right","-1000px");
}

$( document ).ready(function() {
  if ($('.wrap-image').length){
    $('.wrap-image')
    .mouseover(function () {
      var thisID=$(this).attr("id");
      var sImage=$('#'+thisID+' img').attr("data-imageslave");
      if(sImage){
      	$('#'+thisID+' img').attr("src", sImage);
      }
    })
    .mouseout(function () {
      var thisID=$(this).attr("id");
      var mImage=$('#'+thisID+' img').attr("data-imagemaster");
      $('#'+thisID+' img').attr("src", mImage);
    });
  }
});

$("#tabs-press .nav-link").on('click',function(){
   let id = this.id
   $("#tabs-press .nav-item").removeClass("d-none")
   $(this).parent().addClass("d-none")
   $(".slider-press-container").removeClass('d-block').addClass('d-none')
   $(`#${id}-container`).removeClass('d-none').addClass('d-block')

})

$("#tabs-events .nav-link").on('click',function(){
   let id = this.id
   $("#tabs-events .nav-item").removeClass("d-none")
   $(this).parent().addClass("d-none")
   $(".slider-events-container").removeClass('d-block').addClass('d-none')
   $(`#${id}-container`).removeClass('d-none').addClass('d-block')

})